import { FormControl, FormGroup, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { Form, Field, Formik } from "formik";
import { FormikTextField } from '../../CommonComponents/FormField.js';
import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { currentTenant, userid } from "../../Common/Credentials";
import { spin } from "../../Common/NewLoader";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import MasterService from "../MasterService";
import FormLabel from "@mui/material/FormLabel";
import { Spinner } from "react-bootstrap";
import deleteIcon from "../../images/Icons/delete.png";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import SelectField from "../../NewUI/NewComponents/SelectField.jsx";
import RoundedTabButton from "../../NewUI/NewComponents/RoundedTabButton.jsx";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
// import { CheckboxWithLabel } from "formik-material-ui";

class NewRoles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props === undefined || this.props.location.state === undefined ? '' : this.props.location.state.id,
      role: "",
      ProductsList: [],
      product: "",
      productid: "",
      screenList: [],
      AddedScreens: [],
      appmaster: [],
      curraddscr: [],
      loading: false,
      loader: false,
      message: '',
      errormsg: '',
      selectedScreens:[]
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.addscreens = this.addscreens.bind(this)
  }

  componentDidMount() {
    if (userid === undefined) {
      this.props.navigate(`/`);
    }
    this.setState({ loading: true })
    MasterService.getProductsScreens(currentTenant).then((response) => {
      this.setState({ ProductsList: response.data.pelist, screenList: response.data.screenslist, loading: false });
    });
    const id = this.props === undefined || this.props.location.state === undefined ? '' : this.props.location.state.id;
    if (id > -1) {
      MasterService.getRolesScreens(id).then(res =>
        this.setState({ roles: res.data, AddedScreens: res.data.screenslist.map(e => Object.assign(e, { pid: e.productid })), role: res.data.name })
      )
    }
  }

  handleChange = (e) => {
    let value = e.target.value
    this.setState({ product: value, productid: this.state.ProductsList.find(e => e.products === value).id, message: '', errormsg: '' });
  };

  addscreens = (values) => {
    if (values !== undefined) {
      let a = this.state.screenList.filter(e => e.pid === this.state.productid)
      let b = this.state.AddedScreens.filter(e => e.pid !== this.state.productid)
      a.filter(e => values.includes(e.screenname) ?
        // this.state.AddedScreens.find(c => c.name === e.name) ? '' :  
        b.push(Object.assign(e, { screenname: e.screenname, screenid: e.screenid })) : ''
      )

      this.setState({AddedScreens:b, message: `Screens added for product - ${this.state.product} :`, errormsg: '',selectedScreens:[], product: "",productid: "", }, () => console.log(this.state.AddedScreens))
    } else {
      this.setState({ AddedScreens: this.state.AddedScreens.filter(e => e.pid !== this.state.productid) })
    }
  }

  RemoveScreen = (s) => {
    this.setState({ AddedScreens: this.state.AddedScreens.filter(e => e.screenname !== s) })
  }

  onSubmit() {
    this.setState({ loader: true })
    let data = {
      id: this.state.id,
      name: this.state.role.toUpperCase(),
      screenslist: this.state.AddedScreens,
      tenantid: currentTenant
    }
    if (this.state.id === -1) {
      MasterService.addRole(data).then(() =>
        this.props.navigate(`/roles`)
      )
        .catch((e) => {
          this.setState({ loader: false, errormsg: e.response.data.message })
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
        })
    } else {
      MasterService.UpdateRole(data).then(() =>
        this.props.navigate(`/roles`)
      )
        .catch((e) => {
          this.setState({ loader: false, errormsg: e.response.data.message })
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
        })
    }
  }
  validate(values) {
    let errors = {};

    if (this.state.role === "") {
      errors.role = "Please Enter Role Name";
    }
    if(this.state.selectedScreens.length===0){
      errors.screens = "Please select at least one screen";
    }
    return errors;
  }
  render() {
    let { role, product, productid, ProductsList, screenList } = this.state;
    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="UI-container">
            <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/masters"},{name:"Roles",path:"/roles"},{name:"New Role",path:null}]}/>
          </div>
            <div className="UI-form-card">
                <div className="text-center">
                  {this.state.loading === true ? (
                    spin
                  ) : (
                    <Formik
                      initialValues={{ role, product, productid, ProductsList, screenList, }}
                      onSubmit={this.onSubmit}
                      validateOnChange={false}
                      validate={this.validate}
                      enableReinitialize={true}
                    >
                      {({ values,errors }) => (
                        <Form autoComplete="off">
                          <div className="form-row">
                           
                              <fieldset className="form-group col-md-3 tw-text-left" >
                                <TextfieldComponent
                                  className="form-control"
                                  type="text"
                                  name="role"
                                  value={this.state.role}
                                  label="Role Name"
                                  variant="standard"
                                  onChange={(e) =>
                                    this.setState({
                                      role: e.target.value, message: '', errormsg: ''
                                    })
                                  }
                                  disabled={this.state.id !== -1}
                                  error={errors?.role}
                                  fullWidth
                                />
                              </fieldset>
                              <fieldset className="form-group col-md-3 tw-text-left" >

                                  <SelectField  list={ProductsList} value={this.state.product} onChange={this.handleChange} label={"Products"} lableKey={"products"} lableValue={"products"}/> 

                                {/* <FormControl sx={{ minWidth: 80 }} className="col-md-12">
                                  <InputLabel id="demo-simple-select-filled-label">Products</InputLabel>
                                  <Select value={this.state.product} variant="standard" onChange={this.handleChange} >
                                    {ProductsList.map((option, i) => {
                                      return (
                                        option.products === "auth" ? '' :
                                          <MenuItem key={i} value={option.products}>
                                            {option.products}
                                          </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl> */}
                              </fieldset>
                              {/* {this.state.message === '' || this.state.message === undefined ? '' : <>
                                <div className="form-group col-md-8 float-left">
                                  {this.state.message}
                                </div>
                                <div className="form-group col-md-8 float-left">
                                  {this.state.curraddscr.toLocaleString()}
                                </div>
                              </>} */}
                            </div>
                            <div className="form-group col-md-12">
                            {this.state.productid === '' ? '' :
                              <div className="form-group col-md-12">
                                <FormControl component="fieldset" style={{ display: "flex" }}>
                                  <label className="text-left">SCREENS</label>
                                  <div className="tw-flex tw-flex-wrap">
                                    {screenList.map((opt, i) => (
                                      opt.pid === this.state.productid ?
                                        <div className="tw-flex tw-flex-wrap  p-1" key={i}>
                                          <div className="mx-1 tw-flex-1 tw-text-nowrap"><RoundedTabButton label={opt.screenname}  checked={this.state.selectedScreens.includes(opt.screenname)} onClick={(e) =>this.setState({ selectedScreens:[...this.state.selectedScreens,e.target.innerHTML]})} size="sm"/></div>

                                          {/* <Field
                                            className="mt-1"
                                            type="checkbox"
                                            name="screens"
                                            style={{
                                              width: '17px',
                                              height: '17px',
                                              accentColor: '#4d4d4d', // this changes the checkbox color in modern browsers
                                              cursor: 'pointer',
                                              marginTop: '4px' // optional alignment tweak
                                            }}
                                            key={opt.screenname}
                                            value={opt.screenname}
                                            label={{ label: opt.screenname }}

                                          /> */}
                                          {/* <div className="ml-3" component="legend">{opt.screenname}</div> */}
                                        </div>
                                        : ''
                                    ))}

                                  </div>
                                </FormControl>
                                <br></br>
                              </div>
                            }
                             {this.state.productid === '' ? '' :<button as="button" className="btn btn-sm hovbuttonColour float-left" onClick={() => this.addscreens(this.state.selectedScreens)}>Add</button>}
                          </div>
                          {this.state.AddedScreens.length === 0 ? '' :
                              <Table className="table table-sm">
                                <TableHead>
                                  <TableRow>
                                    <TableCell className="text-center">Product</TableCell>
                                    <TableCell className="text-center">Screen</TableCell>
                                    <TableCell className="text-center">Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {this.state.AddedScreens.map((e, i) =>
                                    <TableRow key={i}>
                                      <TableCell className="text-center">{e.product}</TableCell>
                                      <TableCell className="text-center">{e.screenname}</TableCell>
                                      <TableCell style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span onClick={() => this.RemoveScreen(e.screenname)}>
                                          <Tooltip title="Delete">
                                            <img src={deleteIcon} height="20px" width="20px" alt="Delete" />
                                          </Tooltip>
                                        </span>
                                      </TableCell>

                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                          }
                              <fieldset className="form-group col-md-12 text-red">{this.state.errormsg}</fieldset>

                              <fieldset className="tw-flex tw-justify-end">

                                {this.state.loader === true ? (
                                  <button className="UI-btn UI-btn-primary mr-1" disabled>
                                    <Spinner animation="border" size="sm" />
                                    &nbsp;{"Saving"}
                                  </button>
                                ) : (
                                  <button className="UI-btn UI-btn-primary mr-1" type="submit">Save</button>
                                )}
                                <Link
                                  className="UI-btn UI-btn-outline"
                                  to={{
                                    pathname: "/roles"
                                  }}
                                  state={{ message: "" }}
                                >Close
                                </Link>
                              </fieldset>
                        </Form>
                      )}
                    </Formik>
                  )}
                </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(NewRoles);
